"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTemplate = exports.FluidPaginatorTokens = exports.FluidFormTokens = exports.createReplacerToken = exports.TOKEN_CLOSE = exports.TOKEN_OPEN = void 0;
const string_helpers_1 = require("./string.helpers");
exports.TOKEN_OPEN = '<~';
exports.TOKEN_CLOSE = '~>';
const createReplacerToken = (token) => `${exports.TOKEN_OPEN}${token}${exports.TOKEN_CLOSE}`;
exports.createReplacerToken = createReplacerToken;
// Defaults
exports.FluidFormTokens = {
    COMPARATOR: (0, exports.createReplacerToken)('COMPARATOR_FIELD')
};
exports.FluidPaginatorTokens = {
    TOTAL_PAGES: (0, exports.createReplacerToken)('TOTAL_PAGES'),
    TOTAL_ITEMS: (0, exports.createReplacerToken)('TOTAL_ITEMS'),
    CURRENT_PAGE: (0, exports.createReplacerToken)('CURRENT_PAGE'),
    RANGE_FROM: (0, exports.createReplacerToken)('RANGE_FROM'),
    RANGE_TO: (0, exports.createReplacerToken)('RANGE_TO'),
    ITEMS_PER_PAGE: (0, exports.createReplacerToken)('ITEMS_PER_PAGE'),
};
const replaceTemplate = (token, template, replaceValue) => {
    const finalValue = typeof replaceValue === "number" ? replaceValue.toString() : replaceValue;
    return (0, string_helpers_1.addFullStop)(template.replace(new RegExp(token, 'g'), finalValue));
};
exports.replaceTemplate = replaceTemplate;
